import SocketChannels from '../../../../socket_server/SocketChannels';

const { USER, CHATS, MATCH, TOURNAMENT, STATUS } = SocketChannels;

// What the admin socket monitors add to the site socket (react/hooks/useSocketIo).
export const STATUS_WATCH_CHANNELS = Object.freeze({ channels: [STATUS], presence: false });

// The channels the site socket listens to, and whether it counts the user
// online in matchmaking. Browsing the site gets the user's own pushes (direct
// messages, the bell, mod counters) and tournaments, and counts as online.
// The netplay page, while
// it is in the page area, claims its chat rooms and match
// (react/netplay/netplayEntry), or only the match in the match popup.
export default function siteSocketChannels({ netplayPage = false, matchOnlyMode = false } = {}) {
	if(!netplayPage) {
		return { channels: [USER, TOURNAMENT], presence: true };
	}
	if(matchOnlyMode) {
		return { channels: [USER, MATCH], presence: true };
	}
	return { channels: [USER, CHATS, MATCH], presence: true };
}
